import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { EquipmentItem } from './equipment-item';

export class EquipmentClass implements ViewModel, EquipmentItem {
  readonly friendlyTypeNameSingular = 'Equipment Class';
  readonly apiRoute: string = CONFIG.apiRoutes.equipmentClass;
  id: string;
  name: string;
  identifier: string;
  json() {
    return {
      id: this.id,
      name: this.name,
      identifier: this.identifier,
    };
  }

  public loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
    this.identifier = data.identifier;
  }
}
